var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 14,
    viewBox: "0 0 6 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000256062 6.73683C-0.00307369 5.30144 0.411903 3.89797 1.19162 2.70758C1.97134 1.51719 3.08 0.594534 4.3745 0.0587034C4.56567 -0.0210829 4.77982 -0.0194809 4.96985 0.0631572C5.15987 0.145795 5.3102 0.3027 5.38776 0.499354C5.46532 0.696008 5.46376 0.916303 5.38343 1.11178C5.30309 1.30725 5.15057 1.46189 4.95939 1.54167C3.95372 1.96061 3.09253 2.67887 2.48616 3.60443C1.87979 4.52999 1.55586 5.6207 1.55586 6.73683C1.55586 7.85296 1.87979 8.94368 2.48616 9.86924C3.09253 10.7948 3.95372 11.5131 4.95939 11.932C5.15057 12.0118 5.30309 12.1664 5.38343 12.3619C5.46376 12.5574 5.46532 12.7777 5.38776 12.9743C5.3102 13.171 5.15987 13.3279 4.96985 13.4105C4.77982 13.4931 4.56567 13.4947 4.3745 13.415C3.08 12.8791 1.97134 11.9565 1.19162 10.7661C0.411903 9.5757 -0.00307369 8.17222 0.000256062 6.73683Z",
    fill: "#7F9D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.9ee010aff9d74d368924c8a8939dc846.svg";
export { ForwardRef as ReactComponent };